/**
 * DemoBanner — Global banner for demo mode
 * Prominent on main dashboard, dismissable on subpages
 */
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sparkles, ArrowRight, X } from 'lucide-react';

export function DemoBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);

  const isMainPage = location.pathname === '/panel' || location.pathname === '/panel/';

  // On subpages: user can dismiss
  if (dismissed && !isMainPage) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-[#F47A3B] to-[#E05A1B] px-4 py-1.5 flex items-center justify-center gap-2"
      data-testid="demo-banner"
    >
      <Sparkles className="w-3 h-3 text-white/80" />
      <span className="text-[11px] text-white font-medium">
        Konto demo — dane przykładowe
      </span>
      <button
        onClick={() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          navigate('/rejestracja');
        }}
        className="ml-1 px-2.5 py-0.5 rounded-full bg-white/20 hover:bg-white/30 text-[10px] text-white font-bold flex items-center gap-1 transition-colors"
        data-testid="demo-banner-signup"
      >
        Załóż konto <ArrowRight className="w-2.5 h-2.5" />
      </button>
      {!isMainPage && (
        <button
          onClick={() => setDismissed(true)}
          className="ml-1 p-0.5 rounded-full hover:bg-white/20 text-white/70 hover:text-white transition-colors"
          data-testid="demo-banner-close"
          aria-label="Zamknij"
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}

/**
 * Check if current user is demo
 */
export function isDemoUser() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.is_demo === true || user.email === 'demo@apisai.pl';
  } catch {
    return false;
  }
}

/**
 * DemoGuard — wraps mutation actions to block them in demo mode
 */
export function useDemoGuard() {
  const isDemo = isDemoUser();

  const guard = (action, fallbackMsg) => {
    if (isDemo) {
      const { toast } = require('sonner');
      toast.info(fallbackMsg || 'Ta akcja nie jest dostępna w trybie demo. Załóż własne konto!');
      return true; // blocked
    }
    return false; // proceed
  };

  return { isDemo, guard };
}
